import * as React from 'react'
import { Block, OgImageBlock } from '@basehub/data/replicache/index'
import { create } from 'zustand'
import {
  OgImageBlockImageLayerType,
  OgImageBlockLayerType,
  OgImageBlockShapeLayerType,
  OgImageBlockTextLayerType,
} from '~/app/(dash)/[team-slug]/(repo)/[repo-slug]/(editor)/explore/components/blocks/og-image/types'
import { useRepoReplicache } from '~/hooks-data/use-repo-replicache'
import { useSyncedValue } from '~/hooks/use-synced-value'
import { idToSourceBlockId } from '@basehub/data/replicache/mutators/repo-space/block/mutators/copy-on-write'
import {
  RepoUndoOps,
  useRepoUndoManager,
} from '~/replicache/frontend/undo-redo/manager'
import { UpdateBlockParams } from '@basehub/data/replicache/mutators/repo-space/block/mutators/crud'
import { useTabsStore } from '../../tabs/store'

export const newTextLayer: OgImageBlockTextLayerType = {
  type: 'text',
  positionX: 400,
  positionY: 215,
  positionZ: 9999,
  width: 400,
  height: 200,
  rotation: 0,
  opacity: 1,
  textValue: 'Text',
  color: '#F3F3F3',
  lineClamp: 1,
  fontFamily: 'Geist',
  fontWeight: 400,
  fontUrl: 'https://utfs.io/f/7b7c064b-76b8-4cce-ab60-262ba59ed706-5ho58b.otf',
  size: 64,
  lineHeight: 76,
  alignHorizontal: 'center',
  alignVertical: 'middle',
}

export const newImageLayer: OgImageBlockImageLayerType = {
  type: 'image',
  positionX: 400,
  positionY: 215,
  positionZ: 9999,
  width: 400,
  height: 200,
  rotation: 0,
  opacity: 1,
  cornerRadius: 0,
  objectFit: 'cover',
  imageValue: {
    type: 'dynamic',
    value: '',
  },
}

export const newShapeLayer: OgImageBlockShapeLayerType = {
  type: 'shape',
  positionX: 500,
  positionY: 215,
  positionZ: 9999,
  width: 200,
  height: 200,
  rotation: 0,
  opacity: 1,
  cornerRadius: 0,
  color: '#F3F3F3',
}

export const blogArticleTemplateLayer: OgImageBlockLayerType[] = [
  {
    positionX: 600,
    positionY: 0,
    positionZ: 1,
    width: 600,
    height: 630,
    rotation: 0,
    opacity: 1,
    type: 'image',
    cornerRadius: 0,
    objectFit: 'cover',
    imageValue: {
      type: 'dynamic',
      value: '',
    },
  },
  {
    positionX: 48,
    positionY: 48,
    positionZ: 2,
    width: 72,
    height: 72,
    rotation: 0,
    opacity: 1,
    type: 'image',
    cornerRadius: 8,
    objectFit: 'cover',
    imageValue: {
      type: 'dynamic',
      value: '',
    },
  },
  {
    positionX: 48,
    positionY: 462,
    positionZ: 3,
    width: 72,
    height: 72,
    rotation: 0,
    opacity: 1,
    type: 'image',
    cornerRadius: 999,
    objectFit: 'cover',
    imageValue: {
      type: 'dynamic',
      value: '',
    },
  },
  {
    positionX: 142,
    positionY: 462,
    positionZ: 4,
    width: 434,
    height: 72,
    rotation: 0,
    opacity: 1,
    type: 'text',
    textValue: 'Author',
    fontFamily: 'Geist',
    fontWeight: 500,
    fontUrl:
      'https://utfs.io/f/94f64bde-ada5-462d-b7fa-f478f79d5fea-torbd6.otf',
    size: 28,
    lineHeight: 34,
    alignHorizontal: 'left',
    alignVertical: 'middle',
    color: '#CCCCCC',
    lineClamp: 1,
  },
  {
    positionX: 48,
    positionY: 148,
    positionZ: 5,
    width: 400,
    height: 116,
    rotation: 0,
    opacity: 1,
    type: 'text',
    textValue: 'Title\n',
    fontFamily: 'Geist',
    fontWeight: 600,
    fontUrl:
      'https://utfs.io/f/30120ddb-c96d-4530-aac3-396a42286e69-bezilo.otf',
    size: 48,
    lineHeight: 58,
    alignHorizontal: 'left',
    alignVertical: 'middle',
    color: '#F3F3F3',
    lineClamp: 2,
  },
  {
    positionX: 47,
    positionY: 280,
    positionZ: 6,
    width: 400,
    height: 152,
    rotation: 0,
    opacity: 1,
    type: 'text',
    textValue: 'Subtitle',
    fontFamily: 'Geist',
    fontWeight: 400,
    fontUrl:
      'https://utfs.io/f/7b7c064b-76b8-4cce-ab60-262ba59ed706-5ho58b.otf',
    size: 32,
    lineHeight: 38,
    alignHorizontal: 'left',
    alignVertical: 'top',
    color: '#CCCCCC',
    lineClamp: 4,
  },
]

export const docsTemplateLayer: OgImageBlockLayerType[] = [
  {
    positionX: 0,
    positionY: 0,
    positionZ: 1,
    width: 1200,
    height: 128,
    rotation: 0,
    opacity: 1,
    type: 'shape',
    cornerRadius: 0,
    color: '#292929',
  },
  {
    positionX: 64,
    positionY: 176,
    positionZ: 2,
    width: 1072,
    height: 86,
    rotation: 0,
    opacity: 1,
    type: 'text',
    textValue: 'Title',
    fontFamily: 'Geist',
    fontWeight: 700,
    fontUrl:
      'https://utfs.io/f/e518c2ff-b493-4727-b9c0-36fea0d614e4-shsu86.otf',
    size: 72,
    lineHeight: 86,
    alignHorizontal: 'left',
    alignVertical: 'middle',
    color: '#FFF',
    lineClamp: 1,
  },
  {
    positionX: 63,
    positionY: 278,
    positionZ: 3,
    width: 1072,
    height: 288,
    rotation: 0,
    opacity: 1,
    type: 'text',
    textValue: 'Subtitle',
    fontFamily: 'Geist',
    fontWeight: 400,
    fontUrl:
      'https://utfs.io/f/7b7c064b-76b8-4cce-ab60-262ba59ed706-5ho58b.otf',
    size: 60,
    lineHeight: 72,
    alignHorizontal: 'left',
    alignVertical: 'top',
    color: '#ACACAC',
    lineClamp: 4,
  },
  {
    positionX: 64,
    positionY: 32,
    positionZ: 4,
    width: 64,
    height: 64,
    rotation: 0,
    opacity: 1,
    type: 'image',
    cornerRadius: 0,
    objectFit: 'cover',
    imageValue: {
      type: 'dynamic',
      value: '',
    },
  },
  {
    positionX: 622,
    positionY: 30,
    positionZ: 5,
    width: 512,
    height: 64,
    rotation: 0,
    opacity: 1,
    type: 'text',
    textValue: 'Category',
    fontFamily: 'Geist',
    fontWeight: 400,
    fontUrl:
      'https://utfs.io/f/7b7c064b-76b8-4cce-ab60-262ba59ed706-5ho58b.otf',
    size: 40,
    lineHeight: 48,
    alignHorizontal: 'right',
    alignVertical: 'middle',
    color: '#FFF',
    lineClamp: 1,
  },
]

export function processRotationInput(newValue: number) {
  // Normalize the value to be within the range of 0 to 360
  let normalizedValue = newValue % 360
  // If normalized value is negative, adjust it to be positive
  if (normalizedValue < 0) {
    normalizedValue += 360
  }
  // Convert values greater than 180 to their negative counterparts
  if (normalizedValue > 180) {
    normalizedValue -= 360
  }
  return normalizedValue
}

// OgBlockStore
type BlockStore = {
  selectedLayerPositionZ: number | null // unique, acts as the id for layers
  setSelectedLayerPositionZ: (selectedLayerPositionZ: number | null) => void
  floatingLabelTwitter: boolean
  setFloatingLabelTwitter: (floatingLabelTwitter: boolean) => void
}
const createBlockStore = () =>
  create<BlockStore>((set) => ({
    selectedLayerPositionZ: null,
    setSelectedLayerPositionZ: (selectedLayerPositionZ: number | null) => {
      set({ selectedLayerPositionZ })
    },
    floatingLabelTwitter: false,
    setFloatingLabelTwitter: (floatingLabelTwitter: boolean) => {
      set({ floatingLabelTwitter })
    },
  }))
const blockStores: Record<string, ReturnType<typeof createBlockStore>> = {}
export const getOgBlockStore = (blockId: string) => {
  if (!blockStores[blockId]) {
    blockStores[blockId] = createBlockStore()
    return blockStores[blockId] as ReturnType<typeof createBlockStore>
  }
  return blockStores[blockId] as ReturnType<typeof createBlockStore>
}

export const useLayerFunctions = ({
  block: _block,
  path,
  shouldSync,
  setSelectedBlockId,
  parent,
}: {
  block: OgImageBlock
  path: string
  shouldSync?: () => boolean
  setSelectedBlockId?: (blockId: string) => void
  parent: Block | undefined | null
}) => {
  const { data } = useRepoReplicache()
  const replicache = data?.replicache
  const setSelectedLayerPositionZ = getOgBlockStore(_block.id)(
    (state) => state.setSelectedLayerPositionZ
  )
  const undoManager = useRepoUndoManager()
  const activeTabKey = useTabsStore((s) => s.activeTab?.key)
  const sourceBlockId = idToSourceBlockId({
    id: _block.id,
    sourceBlockId: _block.sourceBlockId,
  })
  const overriding = parent?.type === 'instance'

  type SelectionEventDetail =
    | { type: 'deselect' }
    | { type: 'select'; layerPositionZ: number }
  type Value = OgImageBlock['constraints'] & {
    _selection?: { undo?: SelectionEventDetail; redo?: SelectionEventDetail }
    _disableUndoRedo?: boolean
  }

  const { value: partialValue, onChange } = useSyncedValue<
    unknown,
    Partial<Value>
  >({
    value: overriding
      ? (_block.value ?? _block.constraints)
      : _block.constraints,
    customEventsKey: `synced-value:og-image:${idToSourceBlockId(_block)}`,
    setValue: React.useCallback(
      async (
        { _disableUndoRedo, ...value },
        { internalValueRef, customEventsKey }
      ) => {
        if (!replicache?.mutate) return
        const getParams = ({
          _selection,
          ...v
        }: Partial<Value>): UpdateBlockParams => ({
          id: _block.id,
          instanceChildTarget: _block.instanceChildTarget,
          data: {
            type: _block.type,
            ...(overriding ? { value: v } : { constraints: v }),
          } as any,
          path,
          strategy: overriding ? 'merge' : 'merge-deep',
          isoNow: new Date().toISOString(),
        })
        const { undo } = await replicache.mutate.updateBlock(getParams(value))
        if (undo && !_disableUndoRedo) {
          undoManager.current?.push({
            redo: [
              {
                op: 'focus',
                args: {
                  preferredTabKey: activeTabKey,
                  focus: {
                    type: 'block:wrapper',
                    blockId: idToSourceBlockId({
                      id: _block.id,
                      sourceBlockId: _block.sourceBlockId,
                    }),
                  },
                },
              },
              { op: 'updateBlock', args: getParams(internalValueRef.current) },
              {
                op: 'customWindowEvent',
                args: { name: customEventsKey, detail: { action: 'sync' } },
              },
              ...(value._selection?.redo
                ? ([
                    {
                      op: 'customWindowEvent',
                      args: {
                        name: `og-select-mgmt:${sourceBlockId}`,
                        detail: value._selection.redo,
                      },
                    },
                  ] satisfies RepoUndoOps)
                : []),
            ],
            undo: [
              {
                op: 'focus',
                args: {
                  preferredTabKey: activeTabKey,
                  focus: {
                    type: 'block:wrapper',
                    blockId: idToSourceBlockId({
                      id: _block.id,
                      sourceBlockId: _block.sourceBlockId,
                    }),
                  },
                },
              },
              { op: 'blockBatchMutations', args: { mutations: undo } },
              {
                op: 'customWindowEvent',
                args: { name: customEventsKey, detail: { action: 'sync' } },
              },
              ...(value._selection?.undo
                ? ([
                    {
                      op: 'customWindowEvent',
                      args: {
                        name: `og-select-mgmt:${sourceBlockId}`,
                        detail: value._selection.undo,
                      },
                    },
                  ] satisfies RepoUndoOps)
                : []),
            ],
          })
        }
      },
      [
        _block.id,
        _block.sourceBlockId,
        _block.type,
        activeTabKey,
        path,
        replicache?.mutate,
        sourceBlockId,
        undoManager,
        overriding,
        _block.instanceChildTarget,
      ]
    ),
    shouldSync,
    rateLimitMs: 1000,
    rateLimitType: 'throttle',
  })

  const value = React.useMemo(
    () => ({ ..._block.constraints, ...partialValue }),
    [_block.constraints, partialValue]
  )
  const valueRef = React.useRef(value)
  valueRef.current = value

  async function addLayer(layer: OgImageBlockLayerType) {
    const oldLayersData = valueRef.current.layersData

    const maxPositionZ = Math.max(...oldLayersData.map((l) => l.positionZ))
    const newLayer = {
      ...layer,
      positionZ: maxPositionZ + 1,
    }
    const newLayersData = [...oldLayersData, newLayer]

    onChange(
      {
        layersData: newLayersData,
        showTemplates: false,
        _selection: {
          redo: { type: 'select', layerPositionZ: newLayer.positionZ },
          undo: { type: 'deselect' },
        },
      },
      { mergeDeep: true } as const
    )
  }

  async function removeLayer(layer: OgImageBlockLayerType) {
    const layerWithoutRemoved = valueRef.current.layersData.filter(
      (l) => l.positionZ !== layer.positionZ
    )
    // Reorder the layers
    const newLayersData = layerWithoutRemoved.map((l) => ({
      ...l,
      positionZ: l.positionZ > layer.positionZ ? l.positionZ - 1 : l.positionZ,
    }))

    onChange(
      {
        layersData: newLayersData,
        _selection: {
          redo: { type: 'deselect' },
          undo: { type: 'select', layerPositionZ: layer.positionZ },
        },
      },
      { mergeDeep: true } as const
    )
  }

  async function updateLayer(
    layer: OgImageBlockLayerType,
    options?: { disableUndoRedo?: boolean }
  ) {
    const oldLayersData = valueRef.current.layersData
    const newLayersData = valueRef.current.layersData.map((l) =>
      l.positionZ === layer.positionZ ? layer : l
    )

    if (oldLayersData === newLayersData) return

    updateLayersData(newLayersData, options)
  }

  // Layer selection
  const selectLayer = React.useCallback(
    (layer: OgImageBlockLayerType) => {
      window.dispatchEvent(
        new CustomEvent(`og-select-mgmt:${sourceBlockId}`, {
          detail: { type: 'select', layerPositionZ: layer.positionZ },
        })
      )
    },
    [sourceBlockId]
  )

  const deselectLayer = React.useCallback(async () => {
    window.dispatchEvent(
      new CustomEvent(`og-select-mgmt:${sourceBlockId}`, {
        detail: { type: 'deselect' },
      })
    )
  }, [sourceBlockId])

  React.useEffect(() => {
    const handleSelectEvent = (e: Event) => {
      if (e instanceof CustomEvent) {
        if (e.detail.type === 'deselect') {
          setSelectedLayerPositionZ(null)
        } else if (e.detail.layerPositionZ) {
          setSelectedBlockId?.(sourceBlockId)
          setSelectedLayerPositionZ(e.detail.layerPositionZ)
        }
      }
    }

    window.addEventListener(
      `og-select-mgmt:${sourceBlockId}`,
      handleSelectEvent
    )
    return () => {
      window.removeEventListener(
        `og-select-mgmt:${sourceBlockId}`,
        handleSelectEvent
      )
    }
  }, [setSelectedLayerPositionZ, sourceBlockId, setSelectedBlockId])

  // Layer reordering
  async function bringToFront(layer: OgImageBlockLayerType) {
    const oldLayersData = valueRef.current.layersData
    const maxPositionZ = Math.max(...oldLayersData.map((l) => l.positionZ))
    const newLayersData = oldLayersData.map((l) => {
      if (l.positionZ === layer.positionZ) {
        return { ...l, positionZ: maxPositionZ }
      }
      if (l.positionZ > layer.positionZ) {
        return { ...l, positionZ: l.positionZ - 1 }
      }
      return l
    })

    await updateLayersData(newLayersData)
  }
  async function bringForward(layer: OgImageBlockLayerType) {
    const oldLayersData = valueRef.current.layersData
    const maxPositionZ = Math.max(...oldLayersData.map((l) => l.positionZ))
    const newLayersData = oldLayersData.map((l) => {
      if (l.positionZ === layer.positionZ) {
        return { ...l, positionZ: Math.min(l.positionZ + 1, maxPositionZ) }
      }
      if (l.positionZ === layer.positionZ + 1) {
        return { ...l, positionZ: l.positionZ - 1 }
      }
      return l
    })

    await updateLayersData(newLayersData)
  }
  async function sendBackward(layer: OgImageBlockLayerType) {
    const oldLayersData = valueRef.current.layersData
    const newLayersData = oldLayersData.map((l) => {
      if (l.positionZ === 0) {
        return l // Keep the background layer unchanged
      }
      if (l.positionZ === layer.positionZ) {
        return { ...l, positionZ: Math.max(l.positionZ - 1, 0) }
      }
      if (l.positionZ === layer.positionZ - 1) {
        return { ...l, positionZ: l.positionZ + 1 }
      }
      return l
    })

    await updateLayersData(newLayersData)
  }
  async function sendToBack(layer: OgImageBlockLayerType) {
    const oldLayersData = valueRef.current.layersData
    const newLayersData = oldLayersData.map((l) => {
      if (l.positionZ === 0) {
        return l // Keep the background layer unchanged
      }
      if (l.positionZ === layer.positionZ) {
        return { ...l, positionZ: 1 }
      }
      if (l.positionZ < layer.positionZ) {
        return { ...l, positionZ: l.positionZ + 1 }
      }
      return l
    })

    await updateLayersData(newLayersData)
  }
  function canBring(layer: OgImageBlockLayerType) {
    const layersData = valueRef.current.layersData.filter(
      (layer) => layer.positionZ !== 0
    )
    return layersData.some((l) => l.positionZ > layer.positionZ)
  }
  function canSend(layer: OgImageBlockLayerType) {
    const layersData = valueRef.current.layersData.filter(
      (layer) => layer.positionZ !== 0
    )
    return layersData.some((l) => l.positionZ < layer.positionZ)
  }

  // Handle the update undo/redo for simple updates
  function updateLayersData(
    newLayersData: OgImageBlockLayerType[],
    options?: {
      disableUndoRedo?: boolean
    }
  ) {
    onChange(
      { layersData: newLayersData, _disableUndoRedo: options?.disableUndoRedo },
      { mergeDeep: true } as const
    )
  }

  // Templates
  function setShowTemplates(showTemplates: boolean) {
    onChange({ showTemplates }, { mergeDeep: true } as const)
  }

  function addTemplate(template: OgImageBlockLayerType[]) {
    const backgroundLayer = valueRef.current.layersData.find(
      (l) => l.positionZ === 0
    ) as OgImageBlockLayerType

    const newLayersData = [backgroundLayer, ...template]

    onChange({ showTemplates: false, layersData: newLayersData }, {
      mergeDeep: true,
    } as const)
  }

  // Reset value
  async function reset() {
    if (!overriding) throw new Error('Cannot reset value when not overriding')
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onChange({} as any, { mergeDeep: false } as const)
  }

  return {
    value,
    addLayer,
    removeLayer,
    updateLayer,
    selectLayer,
    deselectLayer,
    bringToFront,
    bringForward,
    sendBackward,
    sendToBack,
    canBring,
    canSend,
    setShowTemplates,
    addTemplate,
    reset,
  }
}

export type LayerFunctions = ReturnType<typeof useLayerFunctions>

export const geistFont = {
  family: 'Geist',
  variants: ['100', '200', '300', '400', '500', '600', '700', '800', '900'],
  subsets: ['latin'],
  version: '1.3.0',
  lastModified: '2024-03-25',
  files: {
    '100': 'https://utfs.io/f/874d8c72-4365-4ea6-a434-0cdffa9fe93a-si46qi.otf',
    '200': 'https://utfs.io/f/99a09b6b-fddb-4812-af5f-5edfda0b6f6f-sxebgr.otf',
    '300': 'https://utfs.io/f/c2173592-4242-4656-ade2-73c2ceaf24b3-v3vdth.otf',
    regular:
      'https://utfs.io/f/7b7c064b-76b8-4cce-ab60-262ba59ed706-5ho58b.otf',
    '500': 'https://utfs.io/f/94f64bde-ada5-462d-b7fa-f478f79d5fea-torbd6.otf',
    '600': 'https://utfs.io/f/30120ddb-c96d-4530-aac3-396a42286e69-bezilo.otf',
    '700': 'https://utfs.io/f/e518c2ff-b493-4727-b9c0-36fea0d614e4-shsu86.otf',
    '800': 'https://utfs.io/f/12843ec8-3eab-4496-8230-29566afe1509-uyf89q.otf',
    '900': 'https://utfs.io/f/f2fe09a1-8edf-4791-8e75-63e1e2d2f155-sry5x0.otf',
  },
  category: 'sans-serif',
  kind: 'webfonts#webfont',
  menu: 'sans-serif',
}

export const geistMonoFont = {
  family: 'Geist Mono',
  variants: ['100', '200', '300', '400', '500', '600', '700', '800', '900'],
  subsets: ['latin'],
  version: '1.3.0',
  lastModified: '2024-03-25',
  files: {
    '100': 'https://utfs.io/f/b99e57b7-e856-4d2b-98d3-7616498728f6-ss3gg9.otf',
    '200': 'https://utfs.io/f/0d7f8cc3-57b2-437d-ba1a-0a28ef0f935a-pqemy0.otf',
    '300': 'https://utfs.io/f/59331a16-b5b7-4de3-ae1a-f8ba718162b0-v33se0.otf',
    regular:
      'https://utfs.io/f/d3512800-6dec-4904-b8b9-d6d9dc080d06-eyywsi.otf',
    '500': 'https://utfs.io/f/1b71f874-60ef-4926-babe-6477780a8b1a-ucirot.otf',
    '600': 'https://utfs.io/f/afeb270d-a007-4809-8d23-49887b15ee80-6gtrin.otf',
    '700': 'https://utfs.io/f/a5e26d1a-c287-4ba0-aca6-a50e56dbef27-ssesyl.otf',
    '800': 'https://utfs.io/f/c47f8d3d-d353-47e3-9492-1f6232558875-uxnmu9.otf',
    '900': 'https://utfs.io/f/9270f0af-6670-4a18-bbb1-9087671c94b1-pkyhe9.otf',
  },
  category: 'monospace',
  kind: 'webfonts#webfont',
  menu: 'monospace',
}
